import { Pipe, PipeTransform } from '@angular/core'
import moment from 'moment'

@Pipe({
  name: 'timeFormat',
  standalone: true,
})
export class TimeFormatPipe implements PipeTransform {
  transform(timeString: string, locale?: string): string {
    if (!timeString) return ''

    try {
      const time = moment(timeString)
      if (locale) {
        time.locale(locale)
      }
      return time.format('LT')
    } catch {
      return ''
    }
  }
}
